import notesImg from "../assets/images/notes.png";
import doubleTickImg from "../assets/images/double-tick.png";
import plusImg from "../assets/images/plus.png";
import { useAddTodoMutation, useDeleteTodoMutation, useEditTodoMutation, useGetTodosQuery } from "../features/api/apiSlice";
import { useState } from "react";
import Loader from "./ui/loaders/Loader";
export default function Header() {

    const [addTodo, { isLoading, isError, isSuccess }] = useAddTodoMutation();
    // const {isError: todosError, isLoading: todosLoading} = useGetTodoQuery()
    const [editTodo, { isLoading: editLoading, isError: editError }] = useEditTodoMutation();
    const [deleteTodo, {isLoading: delLoading, isSuccess: delSuccess, isError: delError}] = useDeleteTodoMutation();
    const { data: todos, isLoading: todosLoading, isError: todosError } = useGetTodosQuery();

    const [text, setText] = useState("");



    const resetForm = () => {
        setText("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        addTodo({
            text,
            completed: false,
            color: 'yellow'
        });
        resetForm();

    }

    // Handle Complete 
    const clearComplete = () => {
        if (!isLoading) {
            console.log(todos);
           
            todos.forEach((element) => {
                if(element.completed === true){
                    deleteTodo(element.id);
                }
            })
        }
        
    }
    const handleComplete = () => {
        if (!isLoading) {
            console.log(todos);
           
            todos.forEach((element) => {
                editTodo({
                    id: element.id,
                    data: {
                        completed: true,
                    },
                });
            })
        }
        
    }

    return (
        <div>
            {
                isLoading ? <Loader /> : <form
                    className="flex items-center bg-gray-100 px-4 py-4 rounded-md" onSubmit={handleSubmit}
                >
                    <img
                        src={notesImg}
                        className="w-6 h-6"
                        alt="Add todo"
                    />
                    <input
                        type="text"
                        placeholder="Type your todo"
                        className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                    />
                    <button disabled={isLoading}
                        type="submit"
                        className={`appearance-none w-8 h-8 bg-[url(${plusImg})] bg-no-repeat bg-contain`}
                    ></button>
                </form>
            }

            <ul className="flex justify-between my-4 text-xs text-gray-500">
                <li className="flex space-x-1 cursor-pointer">
                    <img
                        className="w-4 h-4"
                        src={doubleTickImg}
                        alt="Complete"
                    />
                    <span onClick={handleComplete}>Complete All Tasks</span>
                </li>
                <li className="cursor-pointer" onClick={clearComplete}>Clear completed</li>
            </ul>
        </div>
    );
}